import React from "react"

import "./styles.scss"

const GoBackButton = ({text, goBackFunction}) =>{
    return <div onClick = {() => goBackFunction("login")} className = "goBackObjectiveDetailsPage">{text}</div>
}

export default GoBackButton